import { ResourceOptions } from 'react-admin';
import { MdOutlinePeopleAlt } from 'react-icons/md';

import { Resources } from '../../resource';

// One page serves both routes: `/vault/investors` opens the first vault and `/vault/investors/:id` a given one
// (PRD §14.1). react-admin mounts `edit` at `:id`; the page reads it with useParams and edits nothing.
export { default as list, default as edit } from './Investors';
export { INVESTORS_PERMISSION_RESOURCE } from './constants';

export const name = Resources.vaultInvestors;
export const icon = MdOutlinePeopleAlt;
export const options: ResourceOptions = {
  label: 'module.vaultInvestors.title',
};
